import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      TipoAviso: 0,
      key: 'GENERIC',
      Mensaje: i18n.t('tipos.aviso.generic')
    },
    {
      TipoAviso: 1,
      key: 'CERT_CADUCAR',
      Mensaje: i18n.t('tipos.aviso.cert_caducar')
    },
    {
      TipoAviso: 2,
      key: 'CERT_CADUCADO',
      Mensaje: i18n.t('tipos.aviso.cert_caducado')
    },
    {
      TipoAviso: 3,
      key: 'USER_PWD_CADUCAR',
      Mensaje: i18n.t('tipos.aviso.user_pwd_caducar')
    },
    {
      TipoAviso: 4,
      key: 'IMPORTS_ERROR',
      Mensaje: i18n.t('tipos.aviso.imports_error')
    },
  ]
}

export function TIPOS_AVISO (state) {
  return configHelper.getConfig(state, 'TIPOS_AVISO', GenerateConfig)
}
